import {
    SEAT_SIZE,
    DUPLICATE_OFFSET,
    SPACING_HORIZONTAL,
    SPACING_VERTICAL,
} from '%paysera_seat_selection/js/seatSelection/config/defaults';
import {
    OBJECT_TYPE_SECTOR,
    OBJECT_TYPE_RECTANGLE_TABLE,
    OBJECT_TYPE_ROUND_TABLE,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import createSectorWithRowsAndSeats from '../../orm/actions/createSectorWithRowsAndSeats';
import getSectorDuplicationData from '%paysera_seat_selection/js/seatSelection/services/getSectorDuplicationData';
import getRoundTableDuplicationData from '../../../../services/getRoundTableDuplicationData';
import getRectangleTableDuplicationData from '../../../../services/getRectangleTableDuplicationData';
import createRoundTableWithSeats from '../../orm/actions/createRoundTableWithSeats';
import createRectangleTableWithSeats from '../../orm/actions/createRectangleTableWithSeats';

function pasteFromClipboard() {
    return (dispatch, getState) => {
        const { clipboard } = getState().seat_selection.workflow;
        const { objects } = clipboard;
        if (objects.length === 0) {
            return;
        }
        objects.forEach((object) => {
            if (object.objectType === OBJECT_TYPE_SECTOR) {
                const {
                    x,
                    y,
                    seatsCount,
                    rowsCount,
                } = getSectorDuplicationData(object);
                dispatch(createSectorWithRowsAndSeats({
                    sector: {
                        transformation: { translation: { x, y } },
                    },
                    seatsCount,
                    rowsCount,
                }));
            }
            if (object.objectType === OBJECT_TYPE_ROUND_TABLE) {
                const seats = object.seats.toRefArray().map(seat => seat.id);
                const {
                    x,
                    y,
                    arc,
                    rotation,
                    seatCount,
                    size,
                } = getRoundTableDuplicationData(object, seats);
                dispatch(createRoundTableWithSeats({
                    table: {
                        transformation: {
                            arc,
                            rotation,
                            translation: { x, y },
                        },
                        size,
                    },
                    seatCount,
                }));
            }
            if (object.objectType === OBJECT_TYPE_RECTANGLE_TABLE) {
                const seats = object.seats.toRefArray().map(seat => seat.id);
                const {
                    x,
                    y,
                    width,
                    height,
                    seatCount,
                    seatsEast,
                    seatsNorth,
                    seatsSouth,
                    seatsWest,
                } = getRectangleTableDuplicationData(object, seats);
                dispatch(createRectangleTableWithSeats({
                    table: {
                        transformation: {
                            translation: { x, y },
                        },
                        width,
                        height,
                        seatsEast,
                        seatsNorth,
                        seatsSouth,
                        seatsWest,
                    },
                    seatCount,
                }));
            }
        });
    };
}

export default pasteFromClipboard;
